import PropTypes from "prop-types";
import React, { useState } from "react";
import { useReducer } from "react";
import "./style.css";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import allowedCountries from "../../shares/allowedCountries";
import { t } from "i18next";
import { getCountryCallingCode } from "libphonenumber-js";


export const PhoneNumberInput = ({ property1, className, onChange ,error, placeholder, defaultValue, noMargin, regFlag }) => {
  const [state, dispatch] = useReducer(reducer, {
    property1: property1 || "empty",
  });
  const [warning, setWarning] = useState("");

  const handleChange = (number) => {
    if (!number) {
      onChange("");
      setWarning("");
      return;
    }

    const egyptCode = `+${getCountryCallingCode("EG")}`;

    // Check if the input starts with Egypt's country code after the first 4 digits
    if ((number.startsWith(egyptCode) && number.length >= egyptCode.length + 2 ) || !regFlag) {
      setWarning("");
    } else if (number.length >= egyptCode.length + 2) {
      setWarning(t("makeSure.whatsapp"));
    }else{
      setWarning("");
    }

    onChange(number);
   
  };

  return (
    <div className={noMargin ? '' :"mb-3"}>
      <PhoneInput
        placeholder={placeholder}
        className={`email-input ${state.property1} ${className}`}
        onClick={() => {
          dispatch("click");
        }}
        onChange={(e)=>handleChange(e)}
        value={defaultValue}
        countries={allowedCountries}
        international={false}
      />
       {warning && !error ? <p className="text-primary h6 position-absolute text-start">{warning}</p> :
      <p className="text-danger h6 position-absolute text-start">{error}</p>}
    </div>
  );
};

function reducer(state, action) {
  switch (action) {
    case "click":
      return {
        ...state,
        property1: "phone",
      };
    default:
      break;
  }

  return state;
}

PhoneNumberInput.propTypes = {
  property1: PropTypes.oneOf(["empty", "phone"]),
};
